import React from 'react';
import './cardportfolio.scss';
import imageCanada from '../../assets/portfolioImages/canada.jpg';

function CardPortfolio({ link, iconNodejs, text, iconCss, iconFont, iconReact, iconBots, iconWordp, iconPhp, image }){
    return(
    <div className="card custom-card col-md-3 col-sm-12">
        <a href={ link } target="_blank">
            <img src={ image } className="card-img-top custom-card__img" alt="..." />
        </a>
        <div className="card-body ">
            <a href={ link }  target="_blank">
                <p className="card-text text-white"> { text } </p>
            </a>
            <div className="row">
                <div className="col-4 icono-skill d-flex">
                    <span className="icon-tech"> { iconFont } </span>
                    <span className="icon-tech"> { iconCss } </span>
                    <span className="icon-tech"> { iconReact } </span>
                    <span className="icon-tech"> { iconBots } </span>
                    <span className="icon-tech"> { iconWordp } </span>
                    <span className="icon-tech"> { iconPhp } </span>
                    <span className="icon-tech"> { iconNodejs } </span>
                </div>
            </div>
        </div>
    </div>
    )
}

export default CardPortfolio;